import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import ApplicationLoading from 'components/system/ApplicationLoading';
import { bindActionCreators, Dispatch } from 'redux';
import {
    setErrorHandlerAction,
    SetErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { PortType, RootState, UserPortType } from 'types';
import { translate } from 'utils/translate';
import { getId } from 'utils/formHandlers';

import { VIEW_MODE } from 'data/static';
import { PortManager } from 'utils/IndexedDB';
import { portRecord } from '../../services/ports';

interface SelectPortState {
    ports: UserPortType[];
}

interface SelectPortProps {
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
}
class SelectPort extends Component<SelectPortProps, SelectPortState> {
    constructor(props: SelectPortProps) {
        super(props);
        this.state = {
            ports: [],
        };
    }

    async componentDidMount(): Promise<void> {
        const user = JSON.parse(localStorage.getItem('user') || '{}');

        const storedPortId = localStorage.getItem('port_id');

        if (storedPortId && user.user_ports.map((x: UserPortType) => x.port_id).includes(parseInt(storedPortId))) {
            this.setState(
                {
                    ports: user.user_ports.sort((a: UserPortType, b: UserPortType) =>
                        a.port.name.localeCompare(b.port.name)
                    ),
                },
                () => {
                    this.changePort(parseInt(storedPortId));
                }
            );
        } else {
            if (user.user_ports.length === 1) {
                this.changePort(user.user_ports[0].port_id);
            } else {
                this.setState({
                    ports: user.user_ports.sort((a: UserPortType, b: UserPortType) =>
                        a.port.name.localeCompare(b.port.name)
                    ),
                });
            }
        }
    }

    changePort = async (port_id: number): Promise<void> => {
        this.props.setSystemLoadingAction(true);

        try {
            const res = await portRecord(port_id);
            const originalPort: PortType = res.items;

            // Save **everything in IndexedDB** using PortManager
            const portManager = new PortManager();
            await portManager.savePort(originalPort);

            // Save only port_id in localStorage if you still need quick access
            localStorage.setItem('port_id', originalPort.id.toString());

            this.props.setSystemLoadingAction(false);

            // Navigation is still handled here
            //@ts-ignore
            window.location = `/${VIEW_MODE === 'live' ? 'time' : VIEW_MODE}`;
        } catch (error) {
            this.props.setSystemLoadingAction(false);
            this.props.setErrorHandlerAction(error);
        }
    };

    render() {
        return (
            <>
                <ApplicationLoading></ApplicationLoading>

                <section className="fixed w-screen h-screen left-0 top-0">
                    <Image
                        alt={translate('transit analysis')}
                        className="w-full select-non z-0 h-full object-cover absolute left-0 top-0"
                        src="/static/images/hero.jpg"
                    />
                    <div className="text-center  fixed w-menu bg-white left-0 top-0 h-screen z-10   ">
                        <Image
                            style={{ width: '100%' }}
                            className="w-auto ml-auto mr-auto -mt-10 px-3 mb-4"
                            src="/static/images/logo.svg"
                            alt={translate('transit analysis')}
                        />
                        <Scrollbars className=" h-selectPort text-left">
                            {this.state.ports.map((x, i) => {
                                return (
                                    <div
                                        onClick={() => {
                                            this.changePort(x.port.id);
                                        }}
                                        key={i}
                                        className="px-3  flex flex-col py-1 cursor-pointer leading-5 text-gray-700  hover:text-primary-500 focus:outline-none focus:bg-gray-100 focus:text-primary-500"
                                    >
                                        <div className="font-bold"> {x.port.name}</div>
                                        <div className="text-sm"> {x.port.client_name}</div>
                                    </div>
                                );
                            })}
                        </Scrollbars>
                    </div>
                </section>
            </>
        );
    }
}

const SelectPortStateToProps = (state: RootState) => ({});

const SelectPortDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(SelectPortStateToProps, SelectPortDispatchToProps)(SelectPort);
